// extracted by mini-css-extract-plugin
export var statItem = "_ma-1";
export var statsRow = "_ma-0";